import type { FC } from "react"
import React from "react"
import { Stack } from "@chakra-ui/react"
import { useFormikContext } from "formik"

import CreateProposalReceipts from "createProposal/components/CreateProposalReceipts"
import type {
  Governor,
  GovernorParameters,
  GovernorContract,
  Token,
} from "query/graphql"
import { ExecutableCallType } from "query/graphql"
import SummaryTitle from "createProposal/components/summary/SummaryTitle"
import SummaryDescription from "createProposal/components/summary/SummaryDescription"
import type { CreateProposalFormValues } from "createProposal/types/form"
import { spacing } from "theme/foundations/spacing"

type CreateProposalSummaryProps = {
  governance: Pick<Governor, "chainId" | "id"> & {
    contracts: {
      governor: Pick<GovernorContract, "address" | "type">
    }
    parameters: Pick<GovernorParameters, "proposalThreshold">
    token: Token
  }
  isWhiteLabel: boolean
}

const CreateProposalSummary: FC<CreateProposalSummaryProps> = ({
  governance,
}) => {
  const { values } = useFormikContext<CreateProposalFormValues>()

  const isActionsEmpty =
    values?.actions?.every(
      (action) => action.recipe === ExecutableCallType.Empty,
    ) ?? true
  const shouldDisplayExecutable = !isActionsEmpty

  return (
    <Stack align="center" spacing={spacing.containerGap} width="100%">
      <SummaryTitle title={values.details.title} />

      {shouldDisplayExecutable ? (
        <CreateProposalReceipts chainId={governance.chainId} />
      ) : null}

      <SummaryDescription description={values.details.description} />
    </Stack>
  )
}

export default CreateProposalSummary
